import { TableRowTypes } from "@shared/components/Table/interfaces";
import { Discount, SubscriptionStatus } from "@shared/models/Account";

export type NicheFilesSubscription = {
  id: number;
  chargebee_subscription_id?: string;
  chargebee_checkout_link?: string;
  chargebee_checkout_link_expires_at?: string;
  status?: SubscriptionStatus;
  updated_at?: string;
  activated_at?: string;
  next_billing_at?: string;
  cancelled_at?: string;
  discounts?: Discount[];
  county_ids: number[];
  state_ids: number[];
};

export enum NICHE_FILE_STATUS {
  ACTIVE = "active",
  INACTIVE = "inactive",
  ERROR = "error",
  PROCESSING = "processing",
}

interface CountyFile {
  id: number;
  name: string;
  record_count: number;
  created_at: number;
  county?: {
    name: string;
    state?: {
      name: string;
      abbreviation: string;
    };
  };
}

export interface NicheFile {
  id: number;
  account_id: number;
  county_file_id: number;
  status: NICHE_FILE_STATUS;
  created_at: Date;
  county_file?: CountyFile;
  last_downloaded_by?: string;
  last_downloaded_at?: Date;
  last_sent_at?: Date;
  last_sent_by?: string;
  last_unsent_at?: Date;
  last_unsent_by?: string;
}

export interface NicheFileGrouped extends NicheFile {
  rowType?: TableRowTypes.weekPeriod;
  weekPeriod?: string;
}
